import { render, staticRenderFns } from "./TableCell.vue?vue&type=template&id=5a5e4d0c"
import script from "./TableCell.vue?vue&type=script&lang=js"
export * from "./TableCell.vue?vue&type=script&lang=js"
import style0 from "./TableCell.vue?vue&type=style&index=0&id=5a5e4d0c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports